export { default } from './ImagemAssociado';
